import React, { useState, useEffect } from 'react';
import './MeusPrecatorios.css';
import { getToken } from '../../../../services/api';
import { useNavigate } from 'react-router-dom';
import { MdSearch, MdAdd } from 'react-icons/md';
import SearchModal from './components/SearchModal';

const MeusPrecatorios = () => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [selectedState, setSelectedState] = useState(null);
  const [showList, setShowList] = useState(false);
  const [listState, setListState] = useState(null);
  const navigate = useNavigate();

  // Available states
  const availableStates = ['BA', 'MA', 'RN', 'PB', 'RS', 'PR', 'SP', 'RJ', 'MG', 'MT', 'MS'];

  // State names for display
  const stateNames = {
    'BA': 'Bahia',
    'MA': 'Maranhão',
    'RN': 'Rio Grande do Norte',
    'PB': 'Paraíba',
    'RS': 'Rio Grande do Sul',
    'PR': 'Paraná',
    'SP': 'São Paulo',
    'RJ': 'Rio de Janeiro',
    'MG': 'Minas Gerais',
    'MT': 'Mato Grosso',
    'MS': 'Mato Grosso do Sul'
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const token = getToken();
      const API_URL = process.env.NODE_ENV === 'production' 
        ? process.env.REACT_APP_VERCEL_API_URL 
        : process.env.REACT_APP_LOCAL_API_URL;

      const response = await fetch(`${API_URL}/contacted-precatorios/stats`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar estatísticas');
      }

      const data = await response.json();
      setStats(data.stats || {});
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchClick = (state) => {
    setSelectedState(state);
    setSearchModalOpen(true);
  };

  const handleStateClick = (state) => {
    const stateStats = stats[state];
    if (stateStats && stateStats.total > 0) {
      navigate(`/diretoria-comercial/meus-precatorios/${state}`);
    }
  };

  const handlePrecatorioAdded = () => {
    // Refresh stats after adding a precatorio
    fetchStats();
    setSearchModalOpen(false);
  };

  const getTotalCount = (state) => {
    return stats[state]?.total || 0;
  };

  const getStatusCounts = (state) => {
    return stats[state]?.byStatus || {};
  };

  if (loading) {
    return (
      <div className="meus-precatorios-container">
        <div className="loading">Carregando...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="meus-precatorios-container">
        <div className="error">Erro: {error}</div>
      </div>
    );
  }

  return (
    <div className="meus-precatorios-container">
      <h1>Meus Precatórios</h1>
      <p className="subtitle">
        Gerencie seus precatórios por estado. Clique em "Pesquisar" para adicionar novos precatórios à sua lista.
      </p>

      <div className="states-grid">
        {availableStates.map((state) => {
          const total = getTotalCount(state);
          const statusCounts = getStatusCounts(state);
          
          return (
            <div key={state} className="state-card-wrapper">
              <div 
                className={`state-card ${total === 0 ? 'empty' : ''}`}
                onClick={() => handleStateClick(state)}
              >
                <div className="state-header">
                  <h2>{state}</h2>
                  <span className="state-name">{stateNames[state]}</span>
                </div>

                <div className="state-stats">
                  <div className="main-count">
                    <span className="count-number">{total}</span>
                    <span className="count-label">Precatórios</span>
                  </div>

                  {total > 0 && (
                    <div className="status-breakdown">
                      {Object.entries(statusCounts).map(([status, data]) => (
                        <div key={status} className="status-item">
                          <span className={`status-badge status-${status}`}>
                            {status.replace(/_/g, ' ')}
                          </span>
                          <span className="status-count">{data.count}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {total === 0 && (
                  <div className="empty-state-message">
                    <p>Nenhum precatório adicionado</p>
                    <small>Clique em pesquisar para adicionar</small>
                  </div>
                )}
              </div>

              <button 
                className="search-button-state"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSearchClick(state);
                }}
                title={`Pesquisar precatórios em ${stateNames[state]}`}
              >
                <MdSearch className="button-icon" />
                <span>Pesquisar</span>
              </button>
            </div>
          );
        })}
      </div>

      {searchModalOpen && (
        <SearchModal
          isOpen={searchModalOpen}
          onClose={() => setSearchModalOpen(false)}
          state={selectedState}
          onPrecatorioAdded={handlePrecatorioAdded}
        />
      )}
    </div>
  );
};

export default MeusPrecatorios;